// ContactSection.jsx
import React, { useState } from "react";
import "./../../css/ContactUs.css";
import Heading from "./../../ui/heading";
import  Map from "./../../assets/images/map2.png";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ContactSection = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch("https://www.api.ps-env.com/Addmessage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          Name: form.name,
          PhoneNumber: form.phone,
          Email: form.email,
          Message: form.message
        })
      });
       if (response.ok) {
        toast.success("Message sent successfully!");
        setForm({ name: "", phone: "", email: "", message: "" });
        } else {
          toast.error("Failed to send message.");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      } finally {
      setLoading(false);
    }
  };

  return (
    <section className='contact-section'>
      <div className='map-container'>
        <img src={Map} alt='map' className='map-image' />
      </div>
      <div className='form-wrapper'>
        <div className='form-container'>
          <Heading variant='H2' className='heading'>
            Call us for any inquiry and get in touch with us
          </Heading>
          <form className='contact-form' onSubmit={handleSubmit}>
            <input
              type='text'
              name='name'
              placeholder='Your Name'
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type='phone'
              name='phone'
              placeholder='Phone'
              value={form.phone}
              onChange={handleChange}
              required
            />
            <input
              type='email'
              name='email'
              placeholder='Email Address'
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name='message'
              placeholder='Write a Message'
              rows={10}
              value={form.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type='submit' disabled={loading}>{loading ? "Submitting..." : "Submit Now"}</button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default ContactSection;
